export interface DropdownItemProps {
  isHighlighted?: boolean
  renderRoot?: HTMLElement
  selected?: boolean
  text: string
  tooltip?: string
  value: string | undefined
  [x: string]: unknown
}
